import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {RsvpInfoButton} from '../rsvp-info-button'
import {TicketsUnavailableButtonProps} from '.'

export const TicketsUnavailableButton: React.FC<TicketsUnavailableButtonProps> = ({
  ticketsUnavailableMessages,
  onClick,
}) => <RsvpInfoButton messages={ticketsUnavailableMessages} dataHook={DH.TICKETS_UNAVAILABLE} onClick={onClick} />
